import React, { useContext, useEffect, useState } from 'react'
import { MdFamilyRestroom,MdOutlineKeyboardArrowRight  } from 'react-icons/md';
import { IoIosDocument, IoMdClose } from 'react-icons/io';
import { AiOutlineSearch} from 'react-icons/ai'
import { MdFilterListAlt } from "react-icons/md";
import { PsicoSideMenu } from '../../components/sidemenu';
import { gray30, gray40 } from '../../utils/colors';
import DropDown, { DropDownOption } from '../../components/dropdown';
import { AuthContext } from '../../context/auth_context';
import { Service } from '../../services/api';
import CheckBox from '../../components/checkbox';
import { FaHandshake } from 'react-icons/fa';
import { BiTrash } from 'react-icons/bi';

export default function DocumentosPsico () {

  const {user} = useContext(AuthContext);

  const [state, setState] = useState({
    docs:[],
    tab:0,
    show_agendar_cita:false,
    show_onboarding:user.onboarding === "" || user.onboarding === null  ? true : false,
    tips:[
      {
        image:'https://picsum.photos/200/300',
        title:'Titulo',
        description:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
      }
    ]
  })



  useEffect(()=>{
    
      init();

      return ()=>{}
  },[])


  const init = async ()=> {
    let _documents = await Service('GET', `Document?PageNumber=1&PageSize=999`);
    console.log(_documents);
    setState({...state, docs:_documents.data.data})
  };


  return (
    <div className='container-fluid d-flex h-100'>

      <PsicoSideMenu></PsicoSideMenu>

      <div className='container-fluid d-flex flex-column  h-100'>

        <div className='d-flex flex-column flex-lg-row  bg-light p-2 p-sm-3 '>
          <div className='d-flex align-items-center'>
              <div className='text-dark f-28 bold line-0'>Documentos</div>
          </div>
          <div className='col'></div>
          <div className='col d-flex flex-column flex-sm-row align-items-sm-center'>

              <div className='input--light order-1 order-sm-0'>
                  <div className='bv-icon bv-icon--mid'><AiOutlineSearch size={30}></AiOutlineSearch></div>
                  <input className='bg-transparent' placeholder='Busca Tips, Documentos ...'></input>
              </div>

              <div className='d-flex py-1 py-sm-2 order-0 order-sm-1'>
          
              

                  <div className='pe-2 px-sm-2'>
                      <div className='bv-cta bv-cta--outline'><MdFamilyRestroom size={29} color={gray30}></MdFamilyRestroom></div>
                  </div>
                  <div className='pe-2'>
                      {/* <div className='bv-cta bv-cta--outline'><SiHandshake size={24} color={gray30}></SiHandshake></div> */}
                      <DropDown  
              
                      title={''}
                      icon={<FaHandshake size={24} color={gray30}></FaHandshake>}>

                          <DropDownOption disabled>
                              <div className='d-flex align-items-center px-2'>
                              
                                  <div className='text-dark f-16 bold'>Acuerdos</div>
                      
                                  <div className='col mx-5'></div>
                              
                                  <div className='cursor-pointer text-decoration-underline text-primary bold f-14 prevent-select'>Ver Más</div>
                          
                              </div>
                          </DropDownOption>
                      

                          {/* <DropDownOption>
                              <div className='d-flex align-items-center ps-2'>
                                  <div>
                                      <div className='text-dark f-14 bold'>Sesion 3</div>
                                      <div className='text-gray f-12'>10 octubre 2023</div>
                                  </div>
                                  <div className='col'></div>
                                  <div className='ms-5'>
                                      <div className='bv-icon bv-icon--mid'>
                                          <MdOutlineKeyboardArrowRight size={26} color={gray30}></MdOutlineKeyboardArrowRight>
                                      </div>
                                  </div>
                              </div>
                          </DropDownOption>
                          <DropDownOption>
                              <div className='d-flex align-items-center ps-2'>
                                  <div>
                                      <div className='text-dark f-14 bold'>Sesion 2</div>
                                      <div className='text-gray f-12'>2 octubre 2023</div>
                                  </div>
                                  <div className='col'></div>
                                  <div className='ms-5'>
                                      <div className='bv-icon bv-icon--mid'>
                                          <MdOutlineKeyboardArrowRight size={26} color={gray30}></MdOutlineKeyboardArrowRight>
                                      </div>
                                  </div>
                              </div>
                          </DropDownOption>
                          <DropDownOption>
                              <div className='d-flex align-items-center ps-2'>
                                  <div>
                                      <div className='text-dark f-14 bold'>Sesion 1</div>
                                      <div className='text-gray f-12'>23 Sept. 2023</div>
                                  </div>
                                  <div className='col'></div>
                                  <div className='ms-5'>
                                      <div className='bv-icon bv-icon--mid'>
                                          <MdOutlineKeyboardArrowRight size={26} color={gray30}></MdOutlineKeyboardArrowRight>
                                      </div>
                                  </div>
                              </div>
                          </DropDownOption>
                      
                           */}
                      

                      </DropDown>
                  </div>

                  

                  {/* <div className=''>
                      <div className='bv-cta bv-cta--primary' onClick={()=> {
                          setState({...state, show_agendar_cita:true})
                      }}>
                          Agendar Cita
                      </div>
                  </div> */}
                  

              
                  
              </div>


          
          </div>
        </div>



        <div className='col h-75 d-flex '>
          
          <div className='col-3 overflow-auto hide-scroll bg-light px-4 '>

            <div className='d-flex align-items-center bg-white r-10 p-2'>
              <div className='f-16 text-gray'></div>
              <div className='col'></div>
              <DropDown  
                title={''}
                icon={<MdFilterListAlt size={20} color={gray30}></MdFilterListAlt>}>

                    <DropDownOption>
                        <div className='d-flex align-items-center px-2'>

                        
                            
                            <div className='text-dark f-16 bold'>Filtro</div>
                    
                            <div className='col mx-5'></div>
                        
                            <div className='bv-icon'><IoMdClose size={16} color={gray40}></IoMdClose></div>
                        
                        </div>
                    </DropDownOption>
                    <DropDownOption disabled>
                        <div className='d-flex flex-column ps-2'>
                          <CheckBox checked={true} text="Asignados"></CheckBox>
                          <CheckBox checked={true} text="Nuevo"></CheckBox>
                          <CheckBox checked={true} text="Fecha Ascendente"></CheckBox>
                          <CheckBox checked={true} text="Fecha Descendente"></CheckBox>
                  
                        </div>
                    </DropDownOption>
                    <DropDownOption>
                        <div className='d-flex align-items-center ps-2'>
                          <div className='col'></div>
                          <div className='f-14  bold text-blue'> Aplicar filtro</div>
                          <div className='bv-icon'><MdOutlineKeyboardArrowRight color={gray40}></MdOutlineKeyboardArrowRight></div>
                        </div>
                    </DropDownOption>
                  
              </DropDown>
            </div>

            {state.docs.map((item, i)=>{
                return (
                    <div className='bv-card py-1 mt-2  py-2' >
                        <div className='d-flex align-items-center'>
                            <div className='bv-icon'><IoIosDocument color={gray30}></IoIosDocument></div>
                            <div className='f-14 text-gray bold cursor-pointer' onClick={()=>{
                        window.open(item.documentUrl, '_blank')
                    }}>{item.title}</div>
                            <div className='col'></div>
                            <div className='bv-icon bv-icon--mid cursor-pointer'><BiTrash color={'red'}></BiTrash></div>

                        </div>
                     
                        
                    </div>
                )
            })}
           

    
            <div className='my-5'></div>

        
       
          </div>
      
          <div className='col-9 overflow-auto hide-scroll px-4 '>

            <div className='container'>
          
              <div className='position-relative'>
                <img width="100%" className='mx-auto' src='/assets/bannerdocs.png'></img>

                <div className='position-absolute absolute-center-left ps-4 '>
                  <div className='f-30 bolder line-0'>Explora Nuestro Universo de <br></br> Bienestar y Psicología</div>
                  <br></br>
                  <div className='f-18'>En BienVivir, te ofrecemos una variedad de consejos y <br></br> recursos para fortalecer tu salud mental y tu bienestar. <br></br> Nuestra misión es brindarte herramientas valiosas para<br></br>  una vida más saludable y equilibrada.</div>
                </div>
              </div>

             

            </div>
          
          </div>
          
      

    
        </div>
       
        




      </div>


    </div>
  )
}
